<!--
 * @Author:
 * @LastEditTime: 2023-02-06 15:58:04
 * @Description: zhouhuan
-->

<template>
  <el-card class="h-full" :body-style="{ height: '100%', padding: '20px' }">
    <el-row type="flex">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        clearable
        size="small"
        v-model.trim="attrSearch"
        :placeholder="`${$t('searchForTheAttributeRuleName')}`"
        @keyup.native.enter="getLeftTable('referch')"
        data-cy="inputSearch"
        class="w-200px mr-10px ml-10px"
      ></el-input>
      <el-button type="primary" @click="getLeftTable('referch')" data-cy="searchBtn">{{
        $t('search')
      }}</el-button>
      <el-button
        :disabled="!$hasAccess('createAttr')"
        type="primary"
        @click.stop="openAttrTemplate(null)"
        data-cy="addAttrTemplate"
      >
        {{ $t('addAttributes') }}
      </el-button>
      <el-button
        :disabled="!$hasAccess('createRule')"
        type="primary"
        @click="openAttrTemplateDetailDialog(null)"
        data-cy="addAttrTemplateDetail"
      >
        {{ $t('addRules') }}
      </el-button>
      <el-button :disabled="!$hasAccess('export')" @click="exportExcel" data-cy="exportExcelBtn">
        {{ $t('export') }}
      </el-button>
      <el-button :disabled="!$hasAccess('import')" @click="importFile">
        {{ $t('import') }}
      </el-button>
    </el-row>
    <div style="height: calc(100% - 107px)" class="mt-20px">
      <el-row type="flex" :gutter="20" class="h-full">
        <el-col :span="9" class="h-full">
          <p class="table-header p-5px mb-5px fz-14 b">{{ `${$t('attributeRules')}` }}</p>
          <el-table
            key="auth"
            border
            v-loading="leftTableLoading"
            :data="leftTableData"
            @row-click="showRightTableData"
            highlight-current-row
            height="95%"
            stripe
            row-key="id"
            ref="attributeTable"
            @selection-change="selectionAttributeRule"
            @sort-change="sortChangeLeft"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="40"
            ></el-table-column>
            <el-table-column
              prop="seqNo"
              :label="`${$t('serialNumber')}`"
              sortable="custom"
              width="75"
            ></el-table-column>
            <el-table-column
              prop="name"
              :label="`${$t('rulesName')}`"
              width="160"
              show-overflow-tooltip
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="fileType"
              :label="`${$t('propertiesFile')}`"
              width="120"
              show-overflow-tooltip
              sortable="custom"
            >
              <template slot-scope="scope">{{ getFilterFileType(scope.row.fileType) }}</template>
            </el-table-column>
            <el-table-column
              prop="mark"
              :label="`${$t('remark')}`"
              sortable="custom"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="150" fixed="right">
              <template slot-scope="scope" v-if="scope.row.flag !== 1 && scope.row.flag !== 3">
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click.stop="openAttrTemplate(scope.row)"
                  data-cy="editAttrTemplateBtn"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click.stop="delAttrTemplate([scope.row.id])"
                  data-cy="deleteAttrTemplate"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-20px float-right">
            <el-pagination
              background
              @size-change="getLeftTable('referch')"
              @current-change="getLeftTable"
              :current-page.sync="leftParams.pageno"
              :page-sizes="$pageSizeAll"
              :page-size.sync="leftParams.pagesize"
              :pager-count="5"
              layout="total, sizes, prev, pager, next, jumper"
              :total="leftParams.totalLeftNumber"
            ></el-pagination>
          </div>
        </el-col>
        <el-col :span="15">
          <p class="table-header p-5px mb-5px fz-14 b">{{ `${$t('ruleBreakdown')}` }}</p>
          <el-table
            border
            v-loading="rightTableLoading"
            :data="rightTableData"
            ref="rightTableData"
            highlight-current-row
            height="95%"
            stripe
            row-key="id"
            data-cy="rightTable"
            @sort-change="sortChangeRight"
          >
            <el-table-column
              prop="seqNo"
              :label="`${$t('serialNumber')}`"
              sortable="custom"
              width="75"
            ></el-table-column>
            <el-table-column
              prop="propertyFileField"
              show-overflow-tooltip
              :label="`${$t('propertiesFileField')}`"
              sortable="custom"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="propertyTemplateCode"
              show-overflow-tooltip
              :label="`${$t('propertyTemplateCode')}`"
              sortable="custom"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="propertyTemplateName"
              show-overflow-tooltip
              :label="`${$t('thePropertyTemplateName')}`"
              sortable="custom"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="propertyCode"
              show-overflow-tooltip
              :label="`${$t('propertyCode')}`"
              sortable="custom"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="propertyName"
              show-overflow-tooltip
              :label="`${$t('propertyName')}`"
              sortable="custom"
              width="160"
            ></el-table-column>
            <el-table-column show-overflow-tooltip :label="`${$t('attributeCategory')}`">
              <template slot-scope="scope">
                <span>{{
                  scope.row.propertyType === 0
                    ? `${$t('templateProperties')}`
                    : `${$t('baseProperties')}`
                }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="openAttrTemplateDetailDialog(scope.row)"
                  data-cy="editAttrTemplateDetailBtn"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="delAttrTemplateDetail([scope.row.id])"
                  data-cy="deleteAttrTemplateDetail"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-20px float-right">
            <el-pagination
              background
              @size-change="getRightTable('referch')"
              @current-change="getRightTable"
              :current-page.sync="rightParams.pageno"
              :page-sizes="$pageSizeAll"
              :page-size.sync="rightParams.pagesize"
              :pager-count="5"
              layout="total, sizes, prev, pager, next, jumper"
              :total="rightParams.totalRightNumber"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 弹框部分 -->
    <!-- 属性规则弹框 -->
    <el-dialog
      :title="!isAdd ? `${$t('editTheAttributeRule')}` : `${$t('addedAttributeRules')}`"
      :visible.sync="attrRulesDialog"
      :close-on-click-modal="false"
      @close="closeAttrRulesDialog"
      width="35%"
      v-dialogDrag
    >
      <el-form :model="attrRulesForm" :rules="attrRules" ref="attrTemplateForm" label-width="110px">
        <el-form-item prop="seqNo" :label="`${$t('serialNumber')}`">
          <el-input v-model.number="attrRulesForm.seqNo"></el-input>
        </el-form-item>
        <el-form-item prop="name" :label="`${$t('rulesName')}`">
          <el-input v-model.trim="attrRulesForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="fileType" :label="`${$t('propertiesFile')}`">
          <el-select v-model.trim="attrRulesForm.fileType" :placeholder="`${$t('pleaseChoose')}`">
            <el-option
              v-for="item in fileOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="mark" :label="`${$t('remark')}`">
          <el-input v-model.trim="attrRulesForm.mark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAttrRulesDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button
          type="primary"
          @click="saveAttrRulesData"
          :loading="leftBtnLoading"
          data-cy="saveAttrTemplate"
          >{{ `${$t('Sure')}` }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 属性规则明细弹框 -->
    <el-dialog
      :title="
        !isAdd ? `${$t('editTheAttributeRuleDetails')}` : `${$t('addedAttributeRuleDetails')}`
      "
      :visible.sync="attrDetailRulesDialog"
      :close-on-click-modal="false"
      @close="closeAttrDetailRulesDialog"
      width="40%"
      v-dialogDrag
    >
      <el-form
        :model="attrDetailRulesForm"
        :rules="attrDetailRules"
        ref="attrDetailForm"
        label-width="110px"
      >
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item prop="rulesName" :label="`${$t('rulesName')}`">
              <el-input disabled v-model.trim="attrDetailRulesForm.rulesName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fileType" :label="`${$t('propertiesFile')}`">
              <el-select
                disabled
                v-model.trim="attrDetailRulesForm.fileType"
                :placeholder="`${$t('pleaseChoose')}`"
              >
                <el-option
                  v-for="item in fileOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="seqNo" :label="`${$t('serialNumber')}`">
              <el-input v-model.number="attrDetailRulesForm.seqNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="propertyFileField" :label="`${$t('propertiesFileField')}`">
              <el-input v-model.trim="attrDetailRulesForm.propertyFileField"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="propertyType" :label="`${$t('attributeCategory')}`">
              <el-select
                @change="propertyTypeChange"
                v-model.trim="attrDetailRulesForm.propertyType"
                :placeholder="`${$t('pleaseChoose')}`"
              >
                <el-option
                  v-for="item in attrTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="attrDetailRulesForm.propertyType === 0">
            <el-col :span="12">
              <el-form-item prop="propertyTemplateId" :label="`${$t('propertyTemplateCode')}`">
                <el-select
                  @change="templateChange"
                  clearable
                  v-model.trim="attrDetailRulesForm.propertyTemplateId"
                  :placeholder="`${$t('pleaseChoose')}`"
                >
                  <el-option
                    v-for="item in attributeTemplateList"
                    :key="item.id"
                    :label="item.code + '[' + item.name + ']'"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="propertyId" :label="`${$t('propertyCode')}`">
                <el-select
                  @change="propertyChange"
                  clearable
                  :disabled="attrDetailRulesForm.propertyTemplateId === ''"
                  v-model.trim="attrDetailRulesForm.propertyId"
                  :placeholder="`${$t('pleaseChoose')}`"
                >
                  <el-option
                    v-for="item in attributeList"
                    :key="item.id"
                    :label="item.code + '[' + item.name + ']'"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12" v-else>
            <el-form-item prop="propertyCode" :label="`${$t('propertyCode')}`">
              <el-select
                clearable
                v-model.trim="attrDetailRulesForm.propertyCode"
                :placeholder="`${$t('pleaseChoose')}`"
              >
                <el-option
                  v-for="item in attributeTagList"
                  :key="item.label"
                  :label="item.label + '[' + item.value + ']'"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAttrDetailRulesDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="saveAttrDetailRulesData" :loading="rightBtnLoading">{{
          `${$t('save')}`
        }}</el-button>
      </span>
    </el-dialog>

    <wiz-upload-file
      v-dialogDrag
      @refreshList="getLeftTable('referch')"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import { resetObjectValue } from '@/assets/js/commonUtil'
import EncodeRuleManage from '@/services/encodeRule'
import ApiMixinCommon from '@/assets/js/api/common'
import ApiMixinTags from '@/assets/js/api/tags'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'AttributeRuleManage',
  mixins: [ApiMixinCommon, ApiMixinTags, fnMixin],
  components: {
    selectStandardId,
  },
  data() {
    const checkSeqNo = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error(`${this.$t('SerialNumberCannotBeEmpty')}`))
      } else if (value.length > 10) {
        callback(new Error(`${this.$t('LengthCannotExceedTenCharacters')}`))
      } else if (!_.isInteger(value) || value < 1) {
        callback(new Error(`${this.$t('sequenceNumberMustThanZero')}`))
      } else {
        callback()
      }
    }
    const ruleValidation = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error(`${this.$t('pleaseFillInThisField')}`))
      } else {
        callback()
      }
    }
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      uploadVisible: false, // 导出弹框是否可见
      attrSearch: '', // 属性规则搜索字段
      isAdd: true, // 当前操作是否是新增
      fileOptions: [],
      // 左边数据开始
      leftTableData: [],
      leftParams: {
        pagesize: 15,
        pageno: 1,
        isasc: false,
        totalLeftNumber: 0,
      },
      leftTableLoading: false, // 属性规则加载状态
      attrRulesDialog: false, // 属性规则弹框展示与否
      leftBtnLoading: false, // 左边保存按钮加载中
      attrRulesForm: {
        // 左侧弹框表单
        seqNo: '',
        name: '',
        fileType: 0,
        mark: '',
      },
      attrRules: {
        // 左侧弹框表单规则
        name: [{ required: true, validator: ruleValidation, trigger: 'blur' }],
        fileType: [{ required: true, validator: ruleValidation, trigger: 'change' }],
        seqNo: [{ required: true, validator: checkSeqNo, trigger: 'blur' }],
      },
      leftObj: null, // 当前选中的左侧数据集合
      attributeRuleIds: [], // 选中属性规则列表id集合
      //   右边数据开始
      rightTableData: [],
      rightParams: {
        pagesize: 15,
        pageno: 1,
        isasc: false,
        totalLeftNumber: 0,
      },
      rightTableLoading: false, // 右侧明细列表加载状态
      attrDetailRulesDialog: false, // 属性规则明细弹框展示与否
      rightBtnLoading: false, // 右侧保存按钮加载中
      attrDetailRulesForm: {
        // 右侧侧弹框表单
        rulesName: '',
        fileType: 0,
        id: '', // 明细id
        propertyFileField: '',
        seqNo: '',
        propertyTemplateId: '', // 属性模板id
        propertyId: '', // 属性id
        propertyRuleId: '', // 新增时属性规则id
        propertyType: 0,
        propertyTemplateCode: '', // 属性模板代码
        propertyCode: '', // 属性代码
      },
      attrDetailRules: {
        // 右侧侧弹框表单规则
        propertyFileField: [{ required: true, validator: ruleValidation, trigger: 'blur' }],
        propertyType: [{ required: true, message: '请填写该字段', trigger: 'change' }],
        seqNo: [{ required: true, validator: checkSeqNo, trigger: 'blur' }],
      },
      attributeTemplateList: [], // 属性模板下拉列表
      attributeList: [], // 属性下拉列表(模板属性时)
      attributeTagList: [], // 属性下拉列表(基础属性时)
      attrTypeList: [
        {
          value: 0,
          label: '模板属性',
        },
        {
          value: 1,
          label: '基础属性',
        },
      ],
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      // 排序
      sortNameLeft: 'seq_no',
      sortTypeLeft: 'asc',
      sortNameRight: 'seq_no',
      sortTypeRight: 'asc',
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {
    leftObj: {
      handler() {
        this.getRightTable('refrech')
      },
      deep: true,
    },
    'attrDetailRulesForm.propertyTemplateId': {
      handler(val) {
        if (val) {
          this.getAttributeList()
        }
      },
    },
    standardId(newVal) {
      if (newVal) {
        this.getLeftTable('referch')
        this.getAttributeTemplateList()
        this.rightTableData = []
      }
    },
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await EncodeRuleManage.getAttributeRuleTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '属性规则导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      const res = await EncodeRuleManage.uploadAttributeRule(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '属性规则导入明细.xlsx',
          data: res,
        })
        this.getLeftTable('referch')
      }
      this.uploadFileProps.btnLoading = false
    },
    updateStandardId(val) {
      this.standardId = val
    },
    // 左侧属性规则列表排序
    async sortChangeLeft(column) {
      this.sortNameLeft = this.humpToUnderline(column.prop)
      if (column.order === 'ascending') {
        this.sortTypeLeft = 'asc'
        this.getLeftTable('referch')
      } else {
        this.sortTypeLeft = 'desc'
        this.getLeftTable('referch')
      }
    },
    // 右侧规则明细列表排序
    async sortChangeRight(column) {
      this.sortNameRight = this.humpToUnderline(column.prop)
      if (column.order === 'ascending') {
        this.sortTypeRight = 'asc'
        this.getRightTable('referch')
      } else {
        this.sortTypeRight = 'desc'
        this.getRightTable('referch')
      }
    },
    // 过滤属性文件table字段
    getFilterFileType(val) {
      if (this.fileOptions) {
        return _.find(this.fileOptions, ['value', val])
          ? _.find(this.fileOptions, ['value', val]).label
          : ''
      }
      return val
    },
    // 获取属性模板下拉列表
    getAttributeTemplateList() {
      this.queryAttributes({
        params: {
          standard_id: this.standardId,
          keyword: '',
          pageno: 1,
          pagesize: 9999,
          data_type: 1,
        },
      }).then((res) => {
        if (res && res.code === 0 && res.data) {
          this.attributeTemplateList = res.data
        }
      })
    },
    // 获取位号基础属性列表
    async tagBasePropertyList() {
      const res = await EncodeRuleManage.tagBasePropertys({})
      if (res && res.code === 0 && res.data) {
        this.attributeTagList = res.data
      }
    },
    // 获取属性下拉列表
    getAttributeList() {
      this.apiTagAttr({
        method: 'getTagAttributeTemplate',
        params: {
          pageno: 1,
          pagesize: 9999,
          keyword: '',
          class_id: this.attrDetailRulesForm.propertyTemplateId,
        },
      }).then((res) => {
        if (res && res.code === 0 && res.data) {
          this.attributeList = res.data
        }
      })
    },
    // 获取属性文件枚举信息
    async getFileTypeList() {
      const res = await EncodeRuleManage.getfileTypeList({})
      if (res && res.code === 0 && res.data) {
        this.fileOptions = res.data
      }
    },
    // 获取左侧属性规则列表
    async getLeftTable(type) {
      this.leftTableLoading = true
      if (type === 'referch') {
        this.leftParams.pageno = 1
      }
      const res = await EncodeRuleManage.getAttributeRuleList({
        PropertyName: this.attrSearch,
        SkipCount: this.leftParams.pageno,
        MaxResultCount: this.leftParams.pagesize,
        StandardId: this.standardId,
        Sorting: `${this.sortNameLeft} ${this.sortTypeLeft}`,
      })
      this.leftTableLoading = false
      if (res && res.code === 0 && res.data.length) {
        this.leftTableData = res.data
        this.leftParams.totalLeftNumber = res.totalCount
        this.leftObj = res.data[0]
        this.getRightTable()
        this.$nextTick(() => {
          this.$refs.attributeTable.setCurrentRow(this.leftObj)
        })
      } else {
        this.leftTableData = []
        this.leftParams.totalLeftNumber = 0
      }
    },
    async saveAttrRulesData() {
      this.$refs.attrTemplateForm.validate(async (valid) => {
        if (valid) {
          let res = null
          if (this.isAdd) {
            // 新增
            res = await EncodeRuleManage.addAttributeRule({
              standardId: this.standardId,
              ...this.attrRulesForm,
            })
          } else {
            // 批量编辑
            res = await EncodeRuleManage.editAttributeRule([
              { ...this.attrRulesForm, standardId: this.standardId },
            ])
          }
          this.attrRulesDialog = false
          if (res && res.code === 0) {
            this.getLeftTable('referch')
            this.$message.success(res.msg)
          } else {
            this.$message.warning(res.message)
          }
          // return false
        }
      })
    },
    // 打开编辑或者新增弹框
    openAttrTemplate(data) {
      if (data) {
        this.isAdd = false
        const rowData = _.cloneDeep(data)
        resetObjectValue(this.attrRulesForm, rowData)
        this.attrRulesForm.id = rowData.id
      } else {
        // resetObjectValue(this.attrRulesForm, {})
        this.isAdd = true
      }
      this.attrRulesDialog = true
    },
    // 关闭编辑或者新增弹框
    closeAttrRulesDialog() {
      this.$refs.attrTemplateForm.resetFields()
      this.attrRulesDialog = false
      this.attrRulesForm = this.$options.data().attrRulesForm
    },
    // 列表多选事件
    selectionAttributeRule(rows) {
      this.attributeRuleIds = _.map(rows, 'id')
    },
    // 批量删除属性规则
    async delAttrTemplate(ids) {
      if (_.isEmpty(ids)) {
        this.$message.warning(`${this.$t('pleaseSelectTheDataYouWantToDelete')}`)
        return
      }
      this.$confirm(`${this.$t('whetherToDeleteTheData')}?`, this.$t('hint'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await EncodeRuleManage.deleteAttributeRule(ids)
          if (res && res.code === 0) {
            this.$message.success(`${this.$t('deletionSuccessful')}`)
            if (this.leftTableData.length === ids.length && this.leftParams.pageno > 1) {
              this.leftParams.pageno -= 1
            }
            this.getLeftTable()
            this.$refs.attributeTable.clearSelection()
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 单击左侧表格，显示右边表格数据
    showRightTableData(row) {
      this.leftObj = row
    },
    // 右侧属性规则明细方法开始
    // 获取明细列表
    async getRightTable(type) {
      this.rightTableLoading = true
      if (type === 'refrech') {
        this.rightParams.pageno = 1
      }
      const res = await EncodeRuleManage.getAttributeDetailRuleList({
        SkipCount: this.rightParams.pageno,
        MaxResultCount: this.rightParams.pagesize,
        StandardId: this.standardId,
        PropertyRuleId: this.leftObj.id,
        Sorting: '',
      })
      this.rightTableLoading = false
      if (res && res.code === 0 && res.data.length) {
        this.rightTableData = res.data
        this.rightParams.totalRightNumber = res.totalCount
      } else {
        this.rightTableData = []
        this.rightParams.totalRightNumber = 0
      }
    },
    saveAttrDetailRulesData() {
      this.$refs.attrDetailForm.validate(async (valid) => {
        if (valid) {
          if (this.attrDetailRulesForm.propertyType === 0) {
            if (!this.attrDetailRulesForm.propertyTemplateId) {
              this.$message.warning(`${this.$t('pleaseSelectThePropertyTemplateCode')}`)
              return
            }
            if (!this.attrDetailRulesForm.propertyId) {
              this.$message.warning(`${this.$t('pleaseSelectAPropertyCode')}`)
              return
            }
          } else if (!this.attrDetailRulesForm.propertyCode) {
            this.$message.warning(`${this.$t('pleaseSelectAPropertyCode')}`)
            return
          }
          const params = {
            seqNo: this.attrDetailRulesForm.seqNo,
            propertyTemplateId: this.attrDetailRulesForm.propertyTemplateId,
            propertyId: this.attrDetailRulesForm.propertyId,
            propertyFileField: this.attrDetailRulesForm.propertyFileField,
            propertyCode: this.attrDetailRulesForm.propertyCode,
            propertyType: this.attrDetailRulesForm.propertyType,
            propertyTemplateCode: this.attrDetailRulesForm.propertyTemplateCode,
            standardId: this.standardId,
            propertyRuleId: this.leftObj.id,
          }
          let res = null
          if (this.isAdd) {
            // 新增
            res = await EncodeRuleManage.addAttributeDetailRule({
              ...params,
            })
          } else {
            // 编辑
            res = await EncodeRuleManage.editAttributeDetailRule({
              id: this.attrDetailRulesForm.id,
              ...params,
            })
          }
          this.attrDetailRulesDialog = false
          if (res && res.code === 0) {
            this.getRightTable('referch')
            this.$message.success('保存成功')
          } else {
            this.$message.warning(res.msg)
          }
          // return false
        }
      })
    },
    openAttrTemplateDetailDialog(data) {
      if (this.leftObj) {
        if (data) {
          this.isAdd = false
          const rowData = _.cloneDeep(data)
          resetObjectValue(this.attrDetailRulesForm, rowData)
        } else {
          this.isAdd = true
          // resetObjectValue(this.attrDetailRulesForm, {})
          this.attrDetailRulesForm = this.$options.data().attrDetailRulesForm
        }
        this.attrDetailRulesForm.rulesName = this.leftObj.name
        this.attrDetailRulesForm.fileType = this.leftObj.fileType
        this.attrDetailRulesDialog = true
      } else {
        this.$message.info(`${this.$t('thAttributeRuleHasNotBeenSelected')}`)
      }
    },
    closeAttrDetailRulesDialog() {
      this.$refs.attrDetailForm.resetFields()
      this.attrDetailRulesDialog = false
      this.attrDetailRulesForm = this.$options.data().attrDetailRulesForm
    },
    delAttrTemplateDetail(ids) {
      if (_.isEmpty(ids)) {
        this.$message.warning(`${this.$t('pleaseSelectTheDataYouWantToDelete')}`)
        return
      }
      this.$confirm(`${this.$t('whetherToDeleteTheData')}?`, this.$t('hint'), {
        confirmButtonText: this.$t('Sure'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await EncodeRuleManage.deleteAttributeDetailRule(ids)
          if (res && res.code === 0) {
            this.$message.success(`${this.$t('deletionSuccessful')}`)
            if (this.rightTableData.length === ids.length && this.rightParams.pageno > 1) {
              this.rightParams.pageno -= 1
            }
            this.getRightTable()
            this.$refs.attributeTable.clearSelection()
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(() => {})
    },
    // 属性模板代码切换事件
    templateChange(e) {
      this.attrDetailRulesForm.propertyId = ''
      if (e) {
        this.attrDetailRulesForm.propertyTemplateCode = _.find(this.attributeTemplateList, [
          'id',
          e,
        ]).code
      }
      this.attrDetailRulesForm.propertyCode = ''
    },
    // 属性类型改变事件
    propertyTypeChange() {
      this.attrDetailRulesForm.propertyTemplateId = ''
      this.attrDetailRulesForm.propertyTemplateCode = ''
      this.attrDetailRulesForm.propertyCode = ''
      this.attrDetailRulesForm.propertyId = ''
    },
    // 属性代码切换事件
    propertyChange(e) {
      if (e) {
        this.attrDetailRulesForm.propertyCode = _.find(this.attributeList, ['id', e]).columnName
      }
    },
    // 属性规则————导出excel
    exportExcel() {
      if (_.isEmpty(this.attributeRuleIds)) {
        this.$confirm(`${this.$t('ContinueExportingAllData')}`, this.$t('hint'), {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        })
          .then(async () => {
            this.exportBaseRuleByKeyword()
          })
          .catch(() => {})
      } else {
        this.exportBaseRuleById()
      }
    },
    // 属性规则----按关键字导出
    async exportBaseRuleByKeyword() {
      const res = await EncodeRuleManage.exportAttributeRule({
        name: this.attrSearch,
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('属性规则导出结果.xlsx', res)
      }
    },
    // 属性规则————按id导出
    async exportBaseRuleById() {
      const res = await EncodeRuleManage.exportAttributeRule({
        ids: this.attributeRuleIds,
        standardId: this.standardId,
      })
      if (res) {
        this.downLoadExcel('属性规则导出结果.xlsx', res)
      }
    },
    importExcel() {
      this.$refs.excel.uploadExcelVisible = true
      this.uploadVisible = true
    },
    // 导入功能
    changeUploadDialog(data) {
      this.uploadVisible = data
    },
  },
  async created() {
    if (this.standardId) {
      this.getLeftTable() // 获取左侧属性规则列表
      this.getAttributeTemplateList() // 获取属性模板下拉列表数据
    }
    this.getFileTypeList() // 枚举获取属性文件列表
    this.tagBasePropertyList() // 获取位号基础属性列表
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-form-item__content {
  .el-select {
    width: 100% !important;
  }
}
.table-header {
  border: 1px solid #dcdfe6;
  text-indent: 10px;
  color: #363636;
  background-color: #f5f5f5;
}

</style>
